import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { pxToRem } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';
import { BUY_PAGE } from '../../constants/pages';

const NoProductsTypography = styled.p`
  font-size: ${pxToRem(24)};
  letter-spacing: 0;
  line-height: 1.1;
  border-bottom: 1px solid ${themeColors.colorBorderPrimary};
`;

const BrowseLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

const NoProducts = ({ side }) => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <NoProductsTypography>
      {side === 'sell' ? (
        <>
          {t('portfolio.holdings.noHoldingsFirst')}
          <BrowseLink onClick={() => history.push(BUY_PAGE)}>browse</BrowseLink>
          {t('portfolio.holdings.noHoldingsSecond')}
        </>
      ) : (
        t('common.noResults')
      )}
    </NoProductsTypography>
  );
};

NoProducts.propTypes = {
  side: PropTypes.string,
};

export default NoProducts;
